var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover-image"},[_c('img',{attrs:{"src":_vm.image}}),_c('v-btn',{staticClass:"button",attrs:{"title":"Stäng"},on:{"click":_vm.onClose}},[_c('v-icon',[_vm._v("mdi-arrow-collapse")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }